<template>
    <v-card :loading="loading" :disabled="loading">

        <v-app-bar
            color="deep-purple accent-4"
            dark
        >
            <v-toolbar-title class="d-flex align-content-center">
                <v-icon class="cursor-pointer mr-2" @click="golist">mdi-arrow-left</v-icon>
                {{ tabs[selectedTab] }}
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <template v-slot:extension>
                <v-tabs
                    v-model="selectedTab"
                    align-with-title
                >
                    <v-tabs-slider color="purple"></v-tabs-slider>

                    <v-tab
                        v-for="item in tabs"
                        :key="item"
                    >
                        {{ item }}
                    </v-tab>
                </v-tabs>
            </template>
            <v-btn
                v-if="false"
                color="pink"
                fab
                dark
                small
                @click="add"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-app-bar>

        <div v-show="selectedTab === 0" class="pa-6">
            <div class="d-flex align-center">
                <div class="font-weight-bold mr-2">Şirket:</div>
                <span v-if="musteri">{{ musteri.sirket_adi }}</span>
            </div>

            <div class="d-flex align-center py-4">
                <div class="font-weight-bold mr-2">
                    Durumu:
                </div>
                <div v-if="musteri">
                    <v-chip
                        v-if="!musteri.durumu"
                        color="green"
                        dark
                    >
                        Kiralık
                        <v-icon right>mdi-currency-usd</v-icon>
                    </v-chip>
                    <v-chip
                        v-else-if="musteri.durumu === 'demo'"
                        color="orange"
                        dark
                    >
                        Demo ({{ musteri.demo_gun_sayisi }})
                        <v-icon right>mdi-currency-usd-off</v-icon>
                    </v-chip>
                </div>
            </div>

            <div class="d-flex align-center py-4">
                <div class="font-weight-bold mr-2">
                    Müşteri Aktif mi?:
                </div>
                <div v-if="musteri">
                    <v-chip
                        :color="musteri.aktif === '1' ? 'green' : 'orange'"
                        dark
                    >
                        {{ musteri.aktif === '1' ? 'Aktif' : 'Pasif' }}
                        <v-icon right>
                            {{ musteri.aktif === '1' ? 'mdi-check' : 'mdi-alert' }}
                        </v-icon>
                    </v-chip>
                </div>
            </div>

            <div class="d-flex align-center py-4">
                <div class="font-weight-bold mr-2">
                    Makinalar Sayısı:
                </div>
                <div v-if="musteri">
                    <v-chip color="blue" dark class="px-6">
                        {{ makinaSayisi }}
                    </v-chip>
                </div>
            </div>

            <div class="d-flex align-center py-4">
                <div class="font-weight-bold mr-2">
                    Makinalar Çalışıyor mu?:
                </div>
                <div v-if="musteri">
                    <v-chip
                        :color="musteri.makinalar_calismiyor === '0' ? 'green' : 'orange'"
                        dark
                    >
                        {{ musteri.makinalar_calismiyor === '0' ? 'Çalışıyor' : 'Çalışmıyor' }}
                        <v-icon right>
                            {{ musteri.makinalar_calismiyor === '0' ? 'mdi-check' : 'mdi-alert' }}
                        </v-icon>
                    </v-chip>
                </div>
            </div>

            <div class="d-flex align-center py-4">
                <div v-if="musteri">
                    <v-chip
                        color="deep-purple"
                        dark
                    >
                        <v-icon left>mdi-calendar</v-icon>
                        {{ sinceWhen }}
                    </v-chip>
                </div>
            </div>

            <div
                v-if="musteri && musteri.latitude && musteri.longitude"
            >
                <div class="d-flex align-center">
                    <div class="font-weight-bold mr-2">
                        Konum
                    </div>
                    <v-btn
                        icon
                        small
                        color="deep-purple"
                        :href="mapsLink"
                        target="_blank"
                        title="Haritada aç"
                    >
                        <v-icon>mdi-map-marker</v-icon>
                    </v-btn>
                </div>
                <mak-map
                    view-only
                    mini-map
                    :lat="musteri.latitude"
                    :lng="musteri.longitude"/>
            </div>
        </div>

        <musteri-makina-list
            v-if="selectedTab === 1"
            :loading.sync="loading"
            :musteri-id="musteriId"
            photo-upload
        />

        <musteri-kontrol-list
            v-if="selectedTab === 2"
            :musteri-id="musteriId"
        />

    </v-card>
</template>

<script>
    import moment from 'moment';
    import MakMap from '@/components/MakMap.vue'
    import MusteriKontrolList from '@/components/MusteriKontrolList.vue'
    import MusteriMakinaList from './MusteriMakinaList.vue'

    export default {
        name: 'musteri-list',
        components: {
            MusteriMakinaList,
            MusteriKontrolList,
            MakMap,
        },
        data() {
            return {
                tab: 'makinalar',
                visible: false,
                loading: false,
                musteri: null,
                selectedTab: 0,
                tabs: ['Müşteri Profil', 'Makina Listesi', 'Kontroller'],
            };
        },
        computed: {
            mapsLink() {
                const { latitude: lat, longitude: lng } = this.musteri || {};
                return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
            },
            musteriId() {
                return this.$route.params.id;
            },
            sinceWhen() {
                const start = moment(this.musteri.baslangic_zamani);
                const mountCount = moment().diff(start, 'months');
                return `${mountCount} aylık musteri; ${start.format('MMMM YYYY')}'dan beri.`;
            },
            makinaSayisi() {
                return this.musteri?.makinalar?.length || 0;
            },
        },
        methods: {
            golist() {
                this.$router.go(-1);
            },
            fetchMusteriDetail() {
                if (!this.musteriId) {
                    return;
                }
                this.loading = true;
                this.$requests.Musteri.getMusteriDetail(this.musteriId)
                    .then((d) => {
                        this.musteri = d;
                    })
                    .catch((e) => {
                        console.error('error fetching sirket list', e);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
        },
        mounted() {
            this.fetchMusteriDetail();
        },
    };
</script>
